module.exports = __webpack_public_path__ + "img/smashgg.cf3b063d.png";